import axios from "axios";

const api = axios.create({
  baseURL: "https://api.dukanerp.com/api"
});

export default api;  